<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-4">
        <h4 class="card-title text-left">&nbsp;</h4>
        <base-input placeholder="검색어" v-model="keyword"></base-input>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <base-button class="update-button" @click.prevent="getData(1)" type="success">검색</base-button>
      </div>

      <div class="col-sm-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <base-button class="update-button" @click.prevent="goSiteForm()" type="success">사이트추가</base-button>
      </div>
    </div>
    <table class="table table-bordered" style="width: 100%">
      <thead>
        <tr>
          <th style="width: 50px" class="text-center">아이디</th>
          <th style="width: 80px" class="text-center">타입</th>
          <th style="width: 250px" class="text-center">제목</th>
          <th class="text-center">경로</th>
          <th style="width: 100px" class="text-center">복사</th>
          <th style="width: 220px" class="text-center">작업</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in data"
          :key="item.id"
          :style="{
            backgroundColor: item.isVisible === 0 ? '#d3d3d3' : 'white',
            borderBottom: '1px solid #ccc',
          }"
        >
          <td>{{ item.id }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.title }}</td>
          <td>
            <span v-if="item.type === 'static'">{{ item.path | missionPath }}</span>
            <span v-if="item.type === 'poll'">{{ item.path | quizPath }}</span>
            <span v-if="item.type === 'quiz'">{{ item.path | examPath }}</span>
          </td>
          <td><base-button @click.native="copyUrl(item)" type="warning" size="sm">주소복사</base-button></td>
          <td>
            <base-button @click.native="copySite(item.id)" type="warning" size="sm">데이터복사</base-button>
            <base-button @click.native="goSiteForm(item.id)" type="warning" size="sm">수정</base-button>
            <base-button @click.native="removeWebPage(item.id)" type="danger" size="sm">삭제</base-button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BaseInput, BasePagination } from "@/components";
import Endpoints from "@/common/Endpoints";
import { Alert } from "@/util/Alert";

export default {
  components: {
    BaseInput,
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getData();
  },
  watch: {
    currentPage: {
      handler() {
        this.getData(this.currentPage);
      },
    },
  },
  data() {
    return {
      keyword: null,
      totalPages: null,
      currentPage: 1,
      page: 1,
      data: [],
    };
  },
  methods: {
    async getData(page) {
      const params = {};
      params.currentPage = page ? page : 1;
      params.keyword = this.keyword;
      const res = await this.$axios.get("/quests/sites", { params });
      this.data = res.data.data.data;
      this.totalPages = Number(res.data.data.page);
    },

    async goSiteForm(id) {
      if (id) {
        await this.$router.push(`/quest/siteForm?id=${id}`);
      } else {
        await this.$router.push(`/quest/siteForm`);
      }
    },

    copyUrl(item) {
      let url = `${Endpoints.missionUrl}/mission/site/${item.path}`;
      if (item.type === "poll") {
        url = `${Endpoints.missionUrl}/mission/quiz/${item.path}`;
      } else if (item.type === "quiz") {
        url = `${Endpoints.quizUrl}/mission/exam/${item.path}`;
      }
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = url;
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      window.Toast.success("클립보드에 주소가 복사되었습니다");
    },

    async removeWebPage(id) {
      if (await Alert.dangerousConfirmCancel("삭제하시겠습니까?")) {
        await this.$axios.delete(`/quests/sites/${id}`);
        Toast.success("삭제되었습니다");
        await this.getData();
      }
    },
    async copySite(id) {
      const result = await this.$axios.get(`/quests/sites/${id}`);
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = JSON.stringify(result.data.data);
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      window.Toast.success("클립보드에 데이터가 복사되었습니다");
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
